import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react';

const MediumGlassesPlus = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.36344 0.299988C3.4623 0.299988 0.299805 3.46249 0.299805 7.36362C0.299805 11.2648 3.4623 14.4273 7.36344 14.4273C11.2646 14.4273 14.4271 11.2648 14.4271 7.36362C14.4271 3.46249 11.2646 0.299988 7.36344 0.299988ZM4.5 6.9999H6.7998V4.7001C6.7998 4.31347 7.11317 4 7.4998 4C7.88642 4 8.1998 4.31347 8.1998 4.7001V6.9999H10.5C10.8866 6.9999 11.2 7.31338 11.2 7.69998C11.2 8.08658 10.8866 8.39998 10.5 8.39998H8.1998V10.6999C8.1998 11.0865 7.88642 11.4 7.4998 11.4C7.11317 11.4 6.7998 11.0865 6.7998 10.6999V8.39998H4.5C4.11338 8.39998 3.8 8.08658 3.8 7.69998C3.8 7.31338 4.11338 6.9999 4.5 6.9999Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.4979 11.5101L14.9999 14.998L14.0119 15.9899L10.5099 12.502L11.4979 11.5101Z",
                    fill: "currentColor"
                })
            ]
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("circle", {
                    cx: "7.36364",
                    cy: "7.36364",
                    r: "6.36364",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M14.0102 15L11.5001 12.5",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "square"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M10.5 7.5L4.5 7.5",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M7.5 4.5L7.5 10.5",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                })
            ]
        })
    });
};

export { MediumGlassesPlus as default };
